<template>
    <section class="configurations">
        <section class="title">
            <h1>Configurações</h1>
            <p>Aqui está todas as opções para personalização do uso do sistema.</p>
        </section>
        <section class="dash">
            <div class="row">
                <div class="item" v-if="isPermission('config_user_types')">
                    <div class="box" @click="goTo('/configuracoes/tipos-de-usuarios')">
                        <div class="icon">
                            <i class="fal fa-long-arrow-right"></i>
                        </div>
                        <div class="icon-menu">
                            <i class="fal fa-user-cog"></i>
                        </div>
                        <div class="text">Tipos de Usuários</div>
                    </div>
                </div>
                <div class="item" v-if="isPermission('config_others')">
                    <div class="box" @click="goTo('/configuracoes/outros')">
                        <div class="icon">
                            <i class="fal fa-long-arrow-right"></i>
                        </div>
                        <div class="icon-menu">
                            <i class="fal fa-cog"></i>
                        </div>
                        <div class="text">Outras Configurações</div>
                    </div>
                </div>
                <div class="item">
                    <div class="box" @click="goTo('/configuracoes/departamentos')">
                        <div class="icon">
                            <i class="fal fa-long-arrow-right"></i>
                        </div>
                        <div class="icon-menu">
                            <i class="fal fa-address-card"></i>
                        </div>
                        <div class="text">Departamentos</div>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
    import permissions from '@/mixins/permissions'
    export default {
        name: 'login',
        mixins: [ permissions ],
        methods: {
            goTo(page){
                this.$router.push({ path: page })
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
